module.exports = __webpack_public_path__ + "static/media/olho.9031cda9.svg";